                    function closeBar () {
                        dias_expire = 7; /*Dias que queremos que pasen hasta que se vuelva a mostrar la barra*/
                        setCookie("reskyt-install-app", 1, dias_expire);
                        document.getElementById("href-download-app").style.display = "none";
                        return false;
                    }
                    function setCookie(cname, cvalue, exdays) {
                        var d = new Date();
                        d.setTime(d.getTime() + (exdays*24*60*60*1000));
                        var expires = "expires="+ d.toUTCString();
                        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; /*Añadir ;SameSite=None;Secure en caso de que la cookie tenga que ser accesible entre iFrame*/
                    }
                    function getCookie(cname) {
                        var name = cname + "=";
                        var decodedCookie = decodeURIComponent(document.cookie);
                        var ca = decodedCookie.split(';');
                        for(var i = 0; i <ca.length; i++) {
                            var c = ca[i];
                            while (c.charAt(0) == ' ') {
                                c = c.substring(1);
                            }
                            if (c.indexOf(name) == 0) {
                                return c.substring(name.length, c.length);
                            }
                        }
                        return "";
                    }
                    var url = window.location.href;
                    if ( url.indexOf("customapp=") != -1 ) {
                        setCookie("is_app_install_bar", 1, 365);
                    }
                    window.addEventListener("DOMContentLoaded", function () {                                                                  
                                                         
                         var isMobile = true;
                        if(/rktwebview/i.test(navigator.userAgent)){
                            isMobile = false;                            
                        }
                          else if (/Android/i.test(navigator.userAgent)) {
                            document.getElementById("platform-app").innerHTML = " Google Play";                         
                            
                        } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
                            document.getElementById("platform-app").innerHTML = " App Store";
                            
                        } else if (/IEMobile/i.test(navigator.userAgent)) {
                            document.getElementById("platform-app").innerHTML = " Windows Phone";
                            
                        } else {
                            isMobile = false;
                           
                        }
                        if (isMobile && !getCookie("is_app_install_bar") && document.getElementById("href-download-app") && !getCookie("reskyt-install-app")) {
                            document.getElementById("href-download-app").style.display = "block";
                        }                        
                        
                        if (!isMobile || getCookie("is_app_install_bar") || document.getElementById("href-download-app") === null || getCookie("reskyt-install-app")) {
                            document.getElementById("href-download-app").style.display = "none";
                        }
                                
                    });
 